import { Component, Inject, OnInit } from '@angular/core';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ProductosFinancierosService } from '../../services/productos-financieros.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { RegistrarProductoFinancieroComponent } from './registrar-producto-financiero/registrar-producto-financiero.component';
import { HelpersService } from '../../services/tools/helpers.service';
import { EliminarProductoFinancieroComponent } from './eliminar-producto-financiero/eliminar-producto-financiero.component';

@Component({
  selector: 'app-productos-financieros',
  templateUrl: './productos-financieros.component.html',
  styleUrls: ['./productos-financieros.component.scss']
})
export class ProductosFinancierosComponent implements OnInit {

  public mostrarListado:boolean = true;
  public isUpdate:boolean = false;
  public alterTable:any = 'starting';
  public productosFinancieros: any[];

  //Paginador
  errors:any = {};
  searchProcess:any;
  paginate:any = {};
  filterBy:any;
  currentPage = 1;
  lastPage = 1;
  processing:any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;
  searchText:string = "";
  searchSelected: any = {};
  selected:any;

  constructor(
    private authService: AutenticacionService,
    private service: ProductosFinancierosService,
    private router: Router,
    public dialog: MatDialog,
    private helperService: HelpersService
  ) { 
    //Validate user has permission to use this view
    this.checkUserPermission();
  }

  //Valida que tenga permisos de admin
  private checkUserPermission(){
    if(!this.authService.isAdmin()){
      this.router.navigate(['/']);
    }
  }
  ngOnInit() {
    this.getProductos();
    this.resetSelected = this.resetSelected.bind(this);
  }

  //Agregar producto financiero
  agregarProducto(){
    this.isUpdate = false;
    const dialogRef = this.dialog.open(RegistrarProductoFinancieroComponent,{
      data: {flag:false}, 
      height: 'auto',
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isUpdate = false;
    });
  }

  //Función para actualizar
  public actualizarProducto(idProducto:number){
    //Copiamos el objeto para quitar referencia a la variable original
    let productSelect = Object.assign({} , this.productosFinancieros[idProducto]);
    const dialogRef = this.dialog.open(RegistrarProductoFinancieroComponent,{
      data: {producto: productSelect, flag:true}, 
      height: 'auto',
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isUpdate = false;
      if(result.update){
        this.productosFinancieros[idProducto] = result.new;
        console.log("Result: ", result.new);
      }
    });
  }

  public eliminarProducto(idProducto){
    const dialogRef = this.dialog.open(EliminarProductoFinancieroComponent, {
      height: '200px',
      width: '250px',
      data: {id: idProducto }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.eliminar){
        window.location.reload();
      }
    });
  }
  //Paginador
  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }
  
  filtrar(){
    this.goPage(1);
  }

  // MAIN SECTIONS FUNCTIONS
  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  writePermission() {
    return this.service.writePermission();
  }

  search(page = null){
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1 || this.searchSelected.id != ''){
      if(this.searchSelected.id === undefined)
        this.searchSelected.id = '';
      this.searchProcess = this.service.search(this.searchText, page)
          .subscribe(
            response => {
            const content = response.json().content;
            this.productosFinancieros = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.productosFinancieros.length > 0)? false: 'not_found';
          }, error => {
            this.processing = false;

            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
              this.setBackendErrors(error.json().content);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          });
    } else {
      this.getProductos();
    }
  }

  getProductos(page = null){

    this.searchProcess = this.service.obtenerProductos(page)
      .subscribe(response => {
        const content = response.json().content;
        this.productosFinancieros = content.data;
        console.log("Productos: ", this.productosFinancieros);
        this.startPaginate(content);
        this.alterTable = (this.productosFinancieros.length > 0)? false: 'not_result';
      }, error => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.search(page);
    } else {
      this.getProductos(page);
    }

  }

  resetSelected(){
    this.selected = undefined;
    this.errors = {};
  }

  startSelected(){
    this.resetSelected();
    this.selected = this.service.getDefaultSchedule();
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/productos-financieros/productos-financieros.component.ts